import { combineEpics } from 'redux-observable';
import { Observable } from 'rxjs';

import moment from 'moment';
import { failure, SEND_CONTRACT_REQUEST, success } from './action';

const prepare = (payload) => ({
  ...payload,
  birthDate: moment(payload.birthDate).endOf('day').toDate(),
  registerNumberDateOfIssue: moment(payload.registerNumberDateOfIssue).utc().toDate(),
});

const events = (action$, _, { AjaxRequest }) =>
  action$
    .ofType(SEND_CONTRACT_REQUEST)
    .map(({ payload }) => payload)
    .map(prepare)
    .mergeMap((payload) =>
      AjaxRequest.open(
        'post',
        `/admin/contractcustom/contracts/${payload.contractId}/sendtoconsignee`,
        payload,
      )('tudo')
        .flatMap(({ response }) => Observable.of(success(payload, response)))
        .catch((err) => {
          // TODO: aplicar como definitivo quando backend virar completamente
          if (
            (err?.message || '').includes(
              'JSON parse error: Can not deserialize value of type java.time.LocalDate from String',
            )
          ) {
            return AjaxRequest.open('post', `/admin/contractcustom/contracts/${payload.contractId}/sendtoconsignee`, {
              ...payload,
              birthDate: moment(payload.birthDate).format('YYYY-MM-DD'),
            })('tudo')
              .flatMap(({ response }) => Observable.of(success(payload, response)))
              .catch((err) => Observable.of(failure(err)));
          }

          return Observable.of(failure(err));
        }),
    );

export default combineEpics(events);
